import { useEffect, useState } from "react";
import { useFilters } from "../context/FilterContext";
import { getSetting } from "../lib/api";
import { DEFAULT_CATEGORIES, DEFAULT_MOODS } from "../lib/constants";

export default function HomeFilters() {
  const { category, setCategory, collection, setCollection } = useFilters();
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [moods, setMoods] = useState(DEFAULT_MOODS);

  useEffect(() => {
    getSetting("home_categories").then((d) => {
      if (Array.isArray(d?.value) && d.value.length) setCategories(d.value);
    }).catch(() => {});
    getSetting("home_moods").then((d) => {
      if (Array.isArray(d?.value) && d.value.length) setMoods(d.value);
    }).catch(() => {});
  }, []);

  const visibleCats = categories.filter((c) => c.visible !== false);
  const visibleMoods = moods.filter((m) => m.visible !== false);

  const handleCat = (val) => {
    if (val === "All") {
      setCategory("All");
      return;
    }
    setCategory(category === val ? "All" : val);
  };

  const handleMood = (val) => {
    setCollection(collection === val ? "All" : val);
  };

  return (
    <section data-testid="home-filters" className="bg-[#0A0A0A] border-y border-[#262626]">
      {/* Row 1 — categories */}
      <div className="border-b border-[#1a1a1a] overflow-x-auto no-scrollbar">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-5 flex items-center gap-3 min-w-max">
          {visibleCats.map((c) => {
            const active = c.value === "All" ? category === "All" : category === c.value;
            return (
              <button
                key={c.value}
                onClick={() => handleCat(c.value)}
                data-testid={`cat-tab-${c.value.replace(/\s+/g, "-").toLowerCase()}`}
                className={`pill ${active ? "active" : ""}`}
              >
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
      {/* Row 2 — moods */}
      <div className="overflow-x-auto no-scrollbar">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-5 flex items-center gap-3 min-w-max">
          {visibleMoods.map((m) => {
            const active = collection === m.value;
            return (
              <button
                key={m.value}
                onClick={() => handleMood(m.value)}
                data-testid={`mood-tab-${m.value.replace(/\s+/g, "-").toLowerCase()}`}
                className={`pill ${active ? "active" : ""}`}
              >
                {m.label}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
